import { useState } from "react";
import { faqs } from "@/mocks/comics";

export default function Faq() {
  const [openId, setOpenId] = useState<number>(0);

  return (
    <section id="faq" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
            <i className="ri-question-line"></i> 常见问题
          </span>
          <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-4xl">
            你想知道的都在这里
          </h2>
        </div>

        <div className="mt-8 space-y-3">
          {faqs.map((f, i) => {
            const open = openId === i;
            return (
              <div
                key={f.q}
                className="overflow-hidden rounded-2xl border border-background-200 bg-background-100/60"
              >
                <button
                  type="button"
                  onClick={() => setOpenId(open ? -1 : i)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="font-heading text-base text-foreground-950 md:text-lg">
                    {f.q}
                  </span>
                  <span
                    className={`grid h-8 w-8 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-900 transition-transform duration-300 ${
                      open ? "rotate-45" : ""
                    }`}
                  >
                    <i className="ri-add-line"></i>
                  </span>
                </button>
                {open && (
                  <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">
                    {f.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}